<template>
	<div>
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-text class="form-inline">
			<v-text-field outlined dense v-model="query.name" label="名称" hide-details class="search-field-name" />
			<v-select
				outlined
				dense
				label="状态"
				v-model="query.status"
				:items="refs['OrderStatus']"
				hide-details
				clearable
			></v-select>
			<v-btn color="primary" @click="search">
				<v-icon>$search</v-icon>
				查询
			</v-btn>
			<v-icon v-if="queryPairs.length > 0" @click="reset">$close</v-icon>
		</v-card-text>
		<v-data-table-server
			:headers="headers"
			:items="objects"
			@update:options="load"
			:items-length="parseInt(total)"
			:loading="loading"
			:show-select="showSelect"
			:single-select="singleSelect"
			v-model="selected"
			multi-sort
		>
			<template v-slot:top>
				<slot name="batchActions" v-bind:selected="selected"></slot>
			</template>

			<template v-slot:item.status="{ item }">
				{{ item.status }}
			</template>
			<template v-slot:item.totalamt="{ item }">{{ item.totalamt }} / {{ item.payamt }}</template>
			<template v-slot:item.totalqty="{ item }">
				{{ item.totalqty }}
				(
				<template v-for="(oi, idx) in item.items">
					{{ oi.bean_name }} x {{ oi.qty }}g
					<template v-if="idx < item.items.length - 1">,</template>
				</template>
				)
			</template>
			<template v-slot:item.name="{ item }">{{ item.code }} {{ item.name }}</template>
			<template v-slot:item.action="{ item }">
				<slot name="actions" v-bind:item="item"></slot>
			</template>
			<template v-slot:footer>
				<slot name="batchActions" v-bind:selected="selected"></slot>
			</template>
		</v-data-table-server>
	</div>
</template>

<script>
import { clone, valuesIn, toPairsIn, filter, intersection, debounce } from 'lodash-es'
import qs from 'qs'

export default {
	components: {},
	props: {
		type: { type: String, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '日期', align: 'left', sortable: true, value: 'date' },
				{ title: '订单号', sortable: true, value: 'sn' },
				{ title: '总金额', sortable: true, value: 'totalamt' },
				{ title: '总数量', sortable: true, value: 'totalqty' },
				{ title: '状态', sortable: true, value: 'status' },
				{ title: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		const qps = qs.parse(location.search, { ignoreQueryPrefix: true })
		return {
			query: qps,
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			loading: false,
			options: {
				page: 1,
				itemsPerPage: 10,
				sortBy: [],
				sortDesc: []
			},
			refs: {},
			selected: [],
			errors: {}
		}
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
		this.$api.common.meta('order', 'OrderStatus', (response) => {
			this.refs = response
		})
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {},
	methods: {
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
			}
		},
		reset() {
			this.query = {}
		},
		load(options = null) {
			if (!this.options) this.options = {}
			if (options) {
				this.options = options
			}

			let { sortBy, page, itemsPerPage } = this.options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'created_at'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}
			this.currentQuery = clone(this.query)

			this.$api.order.search(
				qwp,
				(response) => {
					// console.log('response', response)
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
